// One description of the <head> tags a page needs. React renders it through react-helmet
// (src/Components/PageSEO.js); scripts/prerender.js serialises the same list into HTML.
const site = require("./site");

/**
 * @returns {Array<{tag: "title", text: string} | {tag: "meta"|"link", attrs: Object}>}
 */
function buildHeadTags(options) {
  const o = options || {};
  const hasPath = o.path !== undefined && o.path !== null;
  const canonical = hasPath ? site.BASE_URL + o.path : null;
  const image = o.image || site.DEFAULT_OG_IMAGE;
  const title = o.title || site.SITE_NAME;
  const description = o.description || "";

  const tags = [
    { tag: "title", text: title },
    { tag: "meta", attrs: { name: "description", content: description } },
  ];
  if (o.noindex) tags.push({ tag: "meta", attrs: { name: "robots", content: "noindex, nofollow" } });
  if (canonical) tags.push({ tag: "link", attrs: { rel: "canonical", href: canonical } });

  tags.push({ tag: "meta", attrs: { property: "og:type", content: o.type || "website" } });
  tags.push({ tag: "meta", attrs: { property: "og:site_name", content: site.SITE_NAME } });
  tags.push({ tag: "meta", attrs: { property: "og:locale", content: "en_US" } });
  tags.push({ tag: "meta", attrs: { property: "og:title", content: title } });
  tags.push({ tag: "meta", attrs: { property: "og:description", content: description } });
  if (canonical) tags.push({ tag: "meta", attrs: { property: "og:url", content: canonical } });
  tags.push({ tag: "meta", attrs: { property: "og:image", content: image } });

  tags.push({ tag: "meta", attrs: { name: "twitter:card", content: "summary_large_image" } });
  tags.push({ tag: "meta", attrs: { name: "twitter:title", content: title } });
  tags.push({ tag: "meta", attrs: { name: "twitter:description", content: description } });
  tags.push({ tag: "meta", attrs: { name: "twitter:image", content: image } });
  return tags;
}

module.exports = { buildHeadTags: buildHeadTags };
